var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPickupHome = function SvgPickupHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.858 15.556h-2.076v-4.861a.694.694 0 0 0-.695-.695H7.921a.694.694 0 0 0-.695.695v4.86H5.143l.004-5.844 4.855-4.966 4.863 4.994-.007 5.817Zm-6.243 0h2.778v-4.167H8.615v4.167Zm7.239-6.816L10.5 3.265a.715.715 0 0 0-.993 0L4.153 8.741c-.253.26-.4.624-.4.998v5.817c0 .766.59 1.389 1.312 1.389h9.877c.723 0 1.312-.623 1.312-1.39V9.74c0-.374-.146-.738-.4-.999Z",
    fill: "#008545"
  })));
};
export default SvgPickupHome;